/* eslint-disable */
import { HotsearchErrorFragment } from "@saleor/fragments/errors";
import { hotsearchFragment } from "@saleor/fragments/hotsearch";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";
import {
  CreateHotsearch,
  CreateHotsearchVariables
} from "./types/CreateHotsearch";
import {
  HotSearchReorder,
  HotSearchReorderVariables
} from "./types/HotSearchReorder";
import {
  RemoveHotsearch,
  RemoveHotsearchVariables
} from "./types/RemoveHotsearch";
import {
  UpdateHotsearch,
  UpdateHotsearchVariables
} from "./types/UpdateHotsearch";

const createHotsearch = gql`
  ${hotsearchFragment}
  ${HotsearchErrorFragment}
  mutation CreateHotsearch($input: HotSearchCreateInput!) {
    HotsearchCreate(input: $input) {
      hotword {
        ...HotsearchFragment
      }
      errors: hotsearchErrors {
        ...HotsearchErrorFragment
      }
    }
  }
`;
export const useHotsearchCreateMutation = makeMutation<
  CreateHotsearch,
  CreateHotsearchVariables
>(createHotsearch);

const removeHotsearch = gql`
  ${HotsearchErrorFragment}
  mutation RemoveHotsearch($id: ID!) {
    hotsearchDelete(id: $id) {
      errors: hotsearchErrors {
        ...HotsearchErrorFragment
      }
    }
  }
`;
export const usehotsearchDeleteMutation = makeMutation<
  RemoveHotsearch,
  RemoveHotsearchVariables
>(removeHotsearch);

const updateHotsearch = gql`
  ${HotsearchErrorFragment}
  mutation UpdateHotsearch($id: ID!, $input: HotSearchUpdateInput!) {
    hotsearchUpdate(id: $id, input: $input) {
      errors: hotsearchErrors {
        ...HotsearchErrorFragment
      }
    }
  }
`;
export const useUpdateHotsearchMutation = makeMutation<
  UpdateHotsearch,
  UpdateHotsearchVariables
>(updateHotsearch);

export const hotSearchReorder = gql`
  mutation HotSearchReorder($move: ReorderInput!) {
    hotsearchReorder(moves: [$move]) {
      hotSearchList {
        sortOrder
        id
        hotWord
      }
      errors: productErrors {
        message
      }
    }
  }
`;

export const useHotSearchReorderMutation = makeMutation<
  HotSearchReorder,
  HotSearchReorderVariables
>(hotSearchReorder);
